import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';
import { PromotionLocation } from '@spartacus/cart/base/root';
import { Order } from '@spartacus/order/root';

import { Observable } from 'rxjs';
import { CheckoutFacade } from '../../../../root';

@Component({
  selector: 'cx-order-confirmation-items',
  templateUrl: './order-confirmation-items.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class OrderConfirmationItemsComponent implements OnInit, OnDestroy {
  promotionLocation: PromotionLocation = PromotionLocation.Checkout;
  order$!: Observable<Order>;

  constructor(protected checkoutService: CheckoutFacade) {}

  ngOnInit() {
    this.order$ = this.checkoutService.getOrderDetails();
  }

  ngOnDestroy() {
    this.checkoutService.clearCheckoutData();
  }
}
